import React, {Fragment, useRef, useState} from "react";
import { Link , NavLink} from "react-router-dom";
import clientconfigwebapp, {
    check_login_appbk,
    convert_to_english_strhk,
    empty_bk,
    getLengt_bk,
    Token_get_appbk,
    modal_searchpage_show, modal_searchpage_hide,
} from "../../clientconfigwebapp";
import {Skeleton} from "@mui/material";
import Grid from "@mui/material/Grid";
import axios from "axios";
import {toast} from "react-toastify";




//import PackageCard from "../PackageCard";
import $ from "jquery";
import PackageCard from "../../components1/PackageCard";
import ProductCard from "../Card_boxs/ProductCard";



const Serarch_box = (props) => {


    const[custom_serarch_box_title,set_custom_serarch_box_title] = useState('');
    const [list_post_Data_serarch_box, set_list_post_Data_serarch_box] = useState([]);


    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    let timer;

    const handleSearchChange = (event) => {
        const newSearchTerm = event.target.value;
        setSearchTerm(newSearchTerm);

        clearTimeout(timer);
        timer = setTimeout(() => {
            Load_api_page(newSearchTerm);
        }, 500);
    };


    const Handler_close_search=(event)=>{

        modal_searchpage_hide()
    }


    const Handler_custom_serarch_box=(event)=>{
        set_custom_serarch_box_title(convert_to_english_strhk(event.target.value));
    }


    const Handler_Searchshow=(event)=>{
        modal_searchpage_show();
    }
    const validate_form_serarch_box=()=> {

var custom_serarch_box_title_val=$("#custom_serarch_box_title").val();

        if (empty_bk(custom_serarch_box_title_val)) {
            ////toast.error('عنوان وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }

        return true;
    }

    const Load_api_page = () => {
///باید قبل return باشه

        var custom_serarch_box_title_val=$("#custom_serarch_box_title").val();


        const validateResult =  validate_form_serarch_box();
        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };


        if(validateResult){

            const data_form_add = {title_search:String(custom_serarch_box_title_val)};


                ///Setloadinghkfullshow("true");
                axios.post(`${clientconfigwebapp.siteurl}api/v1/search-post/`,data_form_add,config)
                    .then((res) => {

                       console.log(res.data, "777777777");


                        if(String(res.data.data).length > 0) {
                            ///Setloadinghkfullshow("false");
                        console.log(res.data, "is posts_get_list");
                            if (res.data.data=="success"){



                                if(String(res.data.posts_get_list).length > 1){  set_list_post_Data_serarch_box(res.data.posts_get_list)  }


                            }else {
                                toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            }


                        }else{
                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }

                        ///localStorage.setItem('token',response.data.Auth.access_token)
                    }).catch((err) =>{
                  ///  Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور اینترنت خود را چک کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 4535!");

                });





        }

    }



    
    

    return (
          <Fragment>



              <div className={"searchboxheader"} >


                  <div  className={"seachbox_full"}>
                      <input onFocus={Handler_Searchshow} onChange={handleSearchChange} type="search" id="custom_serarch_box_title" className="searchboxinput" placeholder="جستجو ..."   />
                      <button type="submit" className="searchbox_btn ">
                          <svg className="text-gray-400 hover:text-gray-500 h-4 w-4 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.966 56.966"><path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23 s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92 c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17 s-17-7.626-17-17S14.61,6,23.984,6z" /></svg>
                      </button>

                      <div className="search_box_fixed " id={"search_box_fixed_modal"} style={{display: "none"}}>

                          <span  style={{"display":"inline-block","marginBottom":"16px","backgroundColor":"#8a8a8a","padding":"13px","width":"34px","height":"39px","textAlign":"center","borderRadius":"5px","color":"white"}} onClick={Handler_close_search}>X</span>

                          <Grid container direction="row" spacing={1}>


                              {list_post_Data_serarch_box.length == 0 ? (
                                  <React.Fragment>

                                  </React.Fragment>


                              ) : (

                                  list_post_Data_serarch_box.map((item_post, index) => {

                                      return (
                                          <Grid item lg={3} md={3} sm={6} xs={6} className="package-searchbk">

                                              {/*<PackageCard  link_to={"courses/" + String(item_post.id_post) } title={item_post.title_post} summery_text={item_post.summary_text} price={item_post.price} price_line={item_post.price_line} img_src={item_post.image_src} />*/}


                                              <ProductCard link_to={"course/" + item_post.id_post}
                                                           data_full_curent_item={item_post}/>

                                          </Grid>
                                      );

                                  })


                              )}


                          </Grid>
                      </div>
                  </div>


              </div>


          </Fragment>


    );
  }

  export default Serarch_box;